import "./AuditHeader.scss"

import { Link } from "react-router-dom"

import { UserRole } from "@/entities/user"
import Icon from "@/shared/components/intrinsic/Icon/Icon"
import { useAppSelector } from "@/store/hooks"
import useSearchState from "@/utils/hooks/useSearchState"


function AuditHeader() {
  const { user } = useAppSelector((state) => state)
  const [companyId] = useSearchState("companyId")
  const url = user.role >= UserRole.StreamManager ? `/companies?company-id=${companyId}` : `/companies/${companyId}`

  return (
    <>
      <div className="audit-layout__header">
        <Link className="audit-layout__link" to={url}>
          <Icon name="chevron-left" />
          {user.role >= UserRole.StreamManager ? "Back to company selection" : "Back"}
        </Link>
      </div>
      <h2>Audit Log</h2>
    </>
  )
}

export default AuditHeader
